import React from "react";
import Icon from "../icon";

type Props = {
  onClose?: () => void;
  title?: string;
  sub?: string;
};

const ModalHeader: React.FC<Props> = ({ title, sub, onClose }) => {
  return (
    <>
      <div className="res-modal__header">
        <h3 className="font-weight-bold h6">{title}</h3>
        <p className="res-modal__header__sub">{sub}</p>
      </div>
      <div className="res-modal__close-btn" onClick={onClose}>
        <Icon name="FA_R-xmark" />
      </div>
    </>
  );
};

export default ModalHeader;
